<h2 i18n class="title-vertical-center title-white title-large">
    @if (errorCode) {
        Error: {{ errorCode | errorCode }}
    } @else {
        Unknown error
    }
</h2>
